export const formTypes = {
  TYPE_LOGIN: "login",
  TYPE_REGISTER: "register",
  TYPE_RESET: "reset",
  TYPE_FORGOT: "forgot",
  TYPE_AGENT_SIGNUP: "agent_signup",
};

export const formsNamesEnums = {
  1: ["name", "lastName"],
  2: "ageGroup",
  3: "ownsHouse",
  4: "currentCountry",
  5: "familyMemberIds",
  6: "passportHold",
  7: "preferredLocationIds",
  8: "noPropertiesLikeToOwn",
  9: "healthPriority",
  10: "dayToDay",
  11: "taxFreeCountry",
  12: "countriesLikeToLiveIds",
  13: "visaFreeCountry",
  14: "interestedCitizenshipId",
  15: "travelDistanceHoliday",
  16: "travelDistanceLovedOnes",
  17: "hobbies",
  18: ["minBudget", "maxBudget"],
  19: ["email", "password", "confirmPassword"],
};

export const surveyFiledsTypes = {
  TYPE_TEXT: "text",
  TYPE_RADIO: "radio",
  TYPE_CHECKBOX: "checkbox",
};

export const REGISTER_SURVEY_FORMS = {
  NAME_FORM: 1,
  AGE_FORM: 2,
  OWN_HOME: 3,
  CURRENT_COUNTRY: 4,
  FAMILY_MEMBERS: 5,
  PASSPORT_COUNTRIES: 6,
  PROPERTY_TYPE_PREFERENCE: 7,
  HOW_MANY_PROPERTIES: 8,
  HEALTH_CARE: 9,
  DAY_TO_DAY: 10,
  TAX_PREFERENCE: 11,
  COUNTRY_PREFERENCE: 12,
  VISA_PREFERENCE: 13,
  CITIZENSHIP_PREFERENCE: 14,
  HOLIDAY_DESTINATION: 15,
  LOVED_ONES: 16,
  HOBBIES: 17,
  BUDGET: 18,
  PASSWORD: 19,
  ELIGIBLE_COUNTRIES: 20,
  THANK_YOU: 21,
};

export const ELIGIBILITY_OPTIONS = {
  NO: "1",
  YES: "2",
};
